import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "about", label: "About" },
  { id: "media", label: "Media" },
  { id: "reviews", label: "Reviews" },
  { id: "booking", label: "Booking" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-[80] transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#050505]/75 border-b border-[#C5A059]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 flex items-center justify-between h-20">
        {/* Logo */}
        <button
          data-testid="logo-link"
          onClick={() => go("hero")}
          className="flex items-center gap-3 group"
        >
          <span
            aria-hidden
            className="w-11 h-11 rounded-full border border-[#C5A059]/60 overflow-hidden flex items-center justify-center group-hover:border-[#C5A059] transition-all duration-500 shrink-0"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_christopher-magician/artifacts/3m8a2v74_1326.jpg"
              alt="Christopher DePamphilis"
              className="w-full h-full object-cover"
            />
          </span>
          <span className="hidden lg:inline font-display text-[#F5F5F0] text-lg tracking-wide whitespace-nowrap group-hover:text-[#C5A059] transition-colors duration-500">
            Christopher DePamphilis
          </span>
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n.id)}
              className="text-[0.78rem] uppercase tracking-[0.22em] text-[#F5F5F0]/80 hover:text-[#E5C07B] transition-colors duration-300"
            >
              {n.label}
            </button>
          ))}
        </nav>

        {/* Right cluster */}
        <div className="flex items-center gap-3">
          <button
            data-testid="book-now-header-btn"
            onClick={() => go("booking")}
            className="hidden md:inline-flex btn-gold !py-2.5 !px-5 !text-[0.7rem]"
          >
            Book Now
          </button>
          <button
            data-testid="mobile-menu-btn"
            className="md:hidden text-[#F5F5F0]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-[#C5A059]/15"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n.id)}
                className="text-left font-display text-3xl text-[#F5F5F0] hover:text-[#C5A059] transition-colors"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-book-now-btn"
              onClick={() => go("booking")}
              className="btn-gold mt-4"
            >
              Book Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
